export default __webpack_public_path__ + "static/media/icon_pass.1ad286b5.svg";